/*
 * Placeholder « machine à écrire » de la carte assistant (.rag-ask).
 *
 * Les questions viennent de l'attribut `data-questions` du gabarit — UNE seule
 * déclaration, alignée à la main sur les `custom_questions` de l'agent RAG. On
 * ne remet SURTOUT pas une liste de repli ici : les deux divergeraient, et le
 * hero finirait par proposer autre chose que la modale de l'assistant.
 */

const TYPE_MS = 45;     // frappe
const ERASE_MS = 22;    // effacement
const HOLD_MS = 1900;   // pause sur une question entière
const GAP_MS = 380;     // pause avant la suivante

function prefersReducedMotion() {
    return window.matchMedia
        && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

function initPlaceholder(form) {
    const ph = form.querySelector('.rag-ask__placeholder');
    const input = form.querySelector('.rag-ask__input');
    if (!ph || !input) return;

    // Le texte s'écrit dans le premier <span> ; le second porte le curseur, qui
    // doit rester en place et clignoter indépendamment.
    const slot = ph.querySelector('span:not(.rag-ask__cursor)');
    if (!slot) return;

    let questions;
    try {
        questions = JSON.parse(ph.dataset.questions || '[]');
    } catch (e) {
        // Un JSON cassé (apostrophe non échappée dans l'attribut, par exemple)
        // ne doit pas emporter le reste du module : la carte doit rester
        // utilisable, simplement sans placeholder animé.
        questions = [];
    }
    if (!questions.length) return;

    // Mouvement réduit : on affiche la première question, fixe, et on s'arrête.
    if (prefersReducedMotion()) {
        slot.textContent = questions[0];
        return;
    }

    let stopped = false;
    let timer = null;

    /*
     * VERROU DÉFINITIF. Dès que l'habitant se sert du champ, la machine à écrire
     * s'arrête pour de bon et cède la place à un libellé fixe.
     *
     * C'est la parade au vol de focus décrit dans le skill : les surcouches
     * d'accessibilité tierces (EqualWeb, UserWay…) focalisent un élément caché
     * une seconde après le chargement, pour TOUS les visiteurs. Qui clique dans
     * le champ pendant cette seconde perd le caret — et sans ce verrou,
     * l'animation repartait par-dessus la saisie, ce qui fait accuser
     * l'animation alors qu'elle n'est pas la cause.
     */
    const stop = () => {
        if (stopped) return;
        stopped = true;
        clearTimeout(timer);
        form.classList.add('is-active');
    };

    input.addEventListener('focus', stop);
    input.addEventListener('input', stop);
    input.addEventListener('keydown', stop);
    form.addEventListener('pointerdown', stop);

    let qi = 0;

    const type = (text, i) => {
        if (stopped) return;
        slot.textContent = text.slice(0, i);
        if (i < text.length) {
            timer = setTimeout(() => type(text, i + 1), TYPE_MS);
        } else {
            timer = setTimeout(() => erase(text, text.length), HOLD_MS);
        }
    };

    const erase = (text, i) => {
        if (stopped) return;
        slot.textContent = text.slice(0, i);
        if (i > 0) {
            timer = setTimeout(() => erase(text, i - 1), ERASE_MS);
        } else {
            // On repart d'une question ENTIÈRE, jamais du milieu d'un mot où une
            // interruption aurait laissé le curseur.
            qi = (qi + 1) % questions.length;
            timer = setTimeout(() => type(questions[qi], 0), GAP_MS);
        }
    };

    type(questions[0], 0);
}

/*
 * Toute la carte doit prendre le clic. Une carte de ~120 px de haut dont seul le
 * champ de 30 px répond laisse les deux tiers de la surface morts : l'habitant
 * clique sur ce qui ressemble à un champ, et rien ne se passe.
 */
function makeCardClickable(form) {
    const input = form.querySelector('.rag-ask__input');
    if (!input) return;

    form.addEventListener('mousedown', (e) => {
        if (e.target === input || e.target.closest('button')) return;
        // Sans ce preventDefault, le focus part sur le <form> et le champ
        // reste vide.
        e.preventDefault();
        input.focus();
    });
}

/*
 * `is-filled` bascule le micro et l'envoi dans leur emplacement commun ; sur ce
 * site le micro n'est pas rendu, mais la classe est posée quand même pour que
 * le composant se comporte comme la référence dès qu'il reviendra.
 *
 * `js-ready` retire le repli CSS `:not(.js-ready):focus-within`, qui révèle
 * l'envoi au seul focus quand le JavaScript n'est pas là.
 */
function wireState(form) {
    const input = form.querySelector('.rag-ask__input');
    if (!input) return;

    const sync = () => form.classList.toggle('is-filled', input.value.trim().length > 0);
    input.addEventListener('input', sync);
    // Le retour arrière du navigateur restaure la valeur SANS déclencher `input`.
    sync();

    form.classList.add('js-ready');
}

function init() {
    document.querySelectorAll('form.rag-ask').forEach((form) => {
        initPlaceholder(form);
        makeCardClickable(form);
        wireState(form);
    });
}

document.addEventListener('DOMContentLoaded', init);
